export const watch = {
  currentOwnerId() {
    this.refresh()
  },
  currentHoaId() {
    this.refresh()
  }
}
